import Vue from 'vue'
import App from './App.vue'
import router from './router'

import HtView from './components/HtView'

Vue.config.productionTip = false

Vue.component(HtView.name, HtView)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
